import { EXAM_LEVELS, SECONDARY_EXAM_LEVELS } from './examLevels.js';
import { ORG_LEVELS } from './orgLevels.js';
import {
  isPublicTuitionCombination,
  type TuitionSubject,
} from './tuitionSubjects/catalog.js';
import {
  isPrimaryOrgLevel,
  isSecondaryOrgLevel,
} from './utils/accessCodeLevels.js';

/** Chemistry classes follow the same level split as the tuition offer. */
export function getClassCodeOrgLevelOptions(subject: TuitionSubject): string[] {
  return ORG_LEVELS.filter(
    level =>
      subject !== 'chemistry' || isPublicTuitionCombination(subject, level)
  );
}

export function getClassCodeExamLevelOptions(
  subject: TuitionSubject,
  orgLevel: string | null | undefined
): string[] {
  const levels = isPrimaryOrgLevel(orgLevel)
    ? ['PSLE']
    : isSecondaryOrgLevel(orgLevel)
      ? SECONDARY_EXAM_LEVELS
      : EXAM_LEVELS;
  return levels.filter(
    level =>
      subject !== 'chemistry' ||
      isPublicTuitionCombination(subject, orgLevel, level)
  );
}

/** Unset cohorts remain valid; a selected Chemistry cohort must fit the offer. */
export function classCodeTuitionLevelError(
  subject: TuitionSubject,
  orgLevel: string | null | undefined,
  examLevel: string | null | undefined
): string | null {
  if (subject !== 'chemistry' || !orgLevel) return null;
  if (!isPublicTuitionCombination(subject, orgLevel))
    return 'Chemistry orgLevel must be Secondary 3 or Secondary 4';
  if (examLevel && !isPublicTuitionCombination(subject, orgLevel, examLevel))
    return 'Chemistry examLevel must be G2, G3 or IP';
  return null;
}
